import * as React from 'react';
import { DynamicPageProps } from '@doltech/routeDefinition';
import { BlogLandingDetail } from '@doltech/modules/lib/blog-landing-detail/BlogLandingDetail';

interface BlogIeltsReviewDetailTemplatePageProps extends DynamicPageProps {}

const BlogIeltsReviewDetailTemplatePage = (props: BlogIeltsReviewDetailTemplatePageProps) => {
  const { seoData, pageData, internalPageLink } = props;
  const { detailData, relatedPosts } = pageData;

  return (
    <BlogLandingDetail
      seoData={seoData}
      detailData={detailData}
      relatedPosts={relatedPosts}
      internalPageLink={internalPageLink}
    />
  );
};

export default BlogIeltsReviewDetailTemplatePage;
